import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { BrandLockup } from "./Logo";
import { NAV } from "../data";

export const Navbar = ({ onApply }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background,padding,box-shadow] duration-500 ${
        scrolled ? "glass py-2.5 shadow-[0_8px_30px_rgba(22,66,117,0.25)]" : "py-4 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-btn" onClick={() => window.scrollTo({ top: 0 })}>
          <BrandLockup eagleH="h-9 sm:h-12" cpcH="h-9 sm:h-11" />
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/-$/,"")}`}
              className={({ isActive }) => `text-sm link-underline transition-colors ${isActive ? "text-accent-2 font-semibold" : "text-white/85 hover:text-white"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button onClick={onApply} data-testid="nav-apply-btn" className="hidden sm:inline-flex btn-primary px-6 py-2.5 text-sm">Apply Now</button>
          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden glass mt-2 mx-4 rounded-2xl" data-testid="mobile-menu">
            <div className="p-6 flex flex-col gap-4">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} end={n.to === "/"} className={({ isActive }) => `text-left text-base ${isActive ? "text-accent-2 font-semibold" : "text-white/85"}`}>{n.label}</NavLink>
              ))}
              <button onClick={() => { setOpen(false); onApply(); }} className="btn-primary px-6 py-3 mt-2" data-testid="mobile-apply-btn">Apply Now</button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
